import { Navigate, useRoutes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BuildersPage from './pages/BuildersPage';
import ProjectsPage from './pages/ProjectsPage';
import TeamPage from './pages/TeamPage';
import EpicsPage from './pages/EpicsPage';
import Page404 from './pages/Page404';
import VeidtPage from './pages/VeidtPage';

export default function Router() {

  const routes = useRoutes([
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/builders',
      element: <BuildersPage />,
    },
    {
      path: '/projects',
      element: <ProjectsPage />,
    },
    {
      path: '/team',
      element: <TeamPage />,
    },
    {
      path: '/epics',
      element: <EpicsPage />,
    },
    {
      path: '/veidt',
      element: <VeidtPage />,
    },
    // Previously '/404' had no route of its own, so the catch-all redirected to
    // it, matched the catch-all again, and rendered a blank page for every
    // unknown URL.
    {
      path: '/404',
      element: <Page404 />,
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
